import {useFormContext} from 'react-hook-form'

import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import FormHelperText from '@mui/material/FormHelperText'
import Select from '@mui/material/Select'

const SelectInput = ({
  items,
  label,
  name,
  options = {},
  helperText,
  error,
  defaultValue = '',
  margin,
  ...props}) => {
  const {register} = useFormContext()

  return (
    <FormControl fullWidth error={error} margin={margin} sx={{'& label': {color: '#71B1AE'}}}>
      <InputLabel id='simple-select-label'>{label}</InputLabel>
      <Select
        {...register(name, options)}
        {...props}
        labelId='simple-select-label'
        id='simple-select'
        defaultValue={defaultValue}
        label={label}>
        <MenuItem value=''>Select an option</MenuItem>
        {
          items.map((item, index) => <MenuItem key={index} value={item.value}>{item.label}</MenuItem>)
        }
      </Select>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  )
}

export default SelectInput
